import { Helmet } from 'react-helmet-async'

export function JapanTripHelmet() {
  const pageUrl = 'https://www.anizone.co.il/japan-trip'
  const pageTitle = 'המסע ליפן לחובבי אנימה ומנגה | AniZone'
  const description =
    'מדריך מקיף ומעודכן לטיול ליפן עבור חובבי אנימה ומנגה. המלצות למסלולים, עונות, תקציב, תחבורה, אוכל, מקומות ייחודיים ועוד – הכל במקום אחד!'
  const image =
    'https://pub-60946b28fb374ff48942bac3163dd658.r2.dev/uploads/2025/05/logo-1747045147075.webp'

  return (
    <Helmet>
      {/* SEO בסיסי */}
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <meta
        name="keywords"
        content="יפן, טיול ליפן, אנימה, מנגה, מדריך טיול, טוקיו, קיוטו, AniZone, חובבי אנימה"
      />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={pageUrl} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content="המסע ליפן | AniZone" />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD Schema.org */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: pageTitle,
            description,
            url: pageUrl,
            image: {
              '@type': 'ImageObject',
              url: image,
            },
            publisher: {
              '@type': 'Organization',
              name: 'AniZone',
              logo: {
                '@type': 'ImageObject',
                url: image,
              },
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: pageTitle,
            description,
            url: pageUrl,
            mainEntityOfPage: {
              '@type': 'WebPage',
              '@id': pageUrl,
            },
            image: {
              '@type': 'ImageObject',
              url: image,
            },
            author: {
              '@type': 'Organization',
              name: 'AniZone',
              url: 'https://www.anizone.co.il',
            },
            publisher: {
              '@type': 'Organization',
              name: 'AniZone',
              logo: {
                '@type': 'ImageObject',
                url: image,
              },
            },
            datePublished: '2025-04-06', // תאריך כתיבה קבוע או דינמי
            dateModified: '2025-04-06',
            keywords: [
              'יפן',
              'טיול ליפן',
              'אנימה',
              'מנגה',
              'מקומות באנימה',
              'טוקיו',
              'קיוטו',
              'חוויות ביפן',
            ],
            isAccessibleForFree: true,
          }),
        }}
      />
    </Helmet>
  )
}
